var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabricksStrengthsWeaknessesAndWhenNotToUseIt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1376 768",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Decision quadrant: when Databricks fits and when Snowflake, BigQuery or Postgres is the better answer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1376,
    height: 768,
    fill: "#0E1F2B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Outfit, Poppins, 'Segoe UI', Helvetica, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 110,
    fontSize: 15,
    fontWeight: 600,
    fill: "#4FD1C5",
    textAnchor: "start",
    letterSpacing: 2.4,
    opacity: 1
  }, "DATABRICKS \xB7 AN HONEST ASSESSMENT"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 164,
    fontSize: 38,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Match the platform to the workload, not the brand"), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 230,
    width: 450,
    height: 210,
    rx: 14,
    fill: "#10303A",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756,
    y: 230,
    width: 444,
    height: 210,
    rx: 14,
    fill: "#0F3A34",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 446,
    width: 450,
    height: 204,
    rx: 14,
    fill: "#10303A",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756,
    y: 446,
    width: 444,
    height: 204,
    rx: 14,
    fill: "#123845",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 525,
    y: 329,
    fontSize: 20,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Snowflake / BigQuery"), /*#__PURE__*/React.createElement("text", {
    x: 525,
    y: 357,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "SQL analytics, analyst-heavy team"), /*#__PURE__*/React.createElement("text", {
    x: 975,
    y: 329,
    fontSize: 20,
    fontWeight: 800,
    fill: "#4FD1C5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Databricks"), /*#__PURE__*/React.createElement("text", {
    x: 975,
    y: 357,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "ML, streaming, unstructured data at scale"), /*#__PURE__*/React.createElement("text", {
    x: 525,
    y: 539,
    fontSize: 20,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Postgres + dbt"), /*#__PURE__*/React.createElement("text", {
    x: 525,
    y: 567,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "GB not TB; reporting and dashboards"), /*#__PURE__*/React.createElement("text", {
    x: 975,
    y: 539,
    fontSize: 20,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Probably over-engineering"), /*#__PURE__*/React.createElement("text", {
    x: 975,
    y: 567,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "small data, real ML ambition \u2014 start simpler"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 690,
    fontSize: 14,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "\u2190 reporting &amp; SQL        workload        ML &amp; streaming \u2192"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270 440.0) rotate(-90)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 14,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "\u2190 gigabytes        data volume        terabytes \u2192")), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 712,
    fontSize: 16,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 3,
    opacity: 1
  }, "WORKFLOX"), /*#__PURE__*/React.createElement("text", {
    x: 1280,
    y: 712,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "end",
    letterSpacing: 0,
    opacity: 1,
    fontStyle: "italic"
  }, "Cost scales with compute; it rewards platform discipline and punishes casual use."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricksStrengthsWeaknessesAndWhenNotToUseIt);
export default __webpack_public_path__ + "static/media/databricks-strengths-weaknesses-and-when-not-to-use-it.142862798d2175063439a1c6b42ba0a7.svg";
export { ForwardRef as ReactComponent };